import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
import { CollegeDialogBoxComponent } from '../college-dialog-box/college-dialog-box.component';
import { PageEvent } from '@angular/material/paginator';
import { CollegePrintComponent } from '../college-print/college-print.component';

@Component({
  selector: 'app-college-data',
  templateUrl: './college-data.component.html',
  styleUrls: ['./college-data.component.scss'],
})
export class CollegeDataComponent implements OnInit {

  collegedataList = [];
  list = true;
  CollegeDataSearchForm;
  APIService: any;
  CgS1CentBoolean = true;
  CgOnlyCentBoolean = true;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  totalItems = 0;
  UniCollege
  UserCollege
  userPermission
  setIntervalSearch: any;
  constructor(
    public umsService: UmsService,
    private fb: FormBuilder,
    public router: Router,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
     this.CollegeDataSearchForm = this.fb.group({
      SearchString: new FormControl(''),
    });
    this.getCollegeData();
  }

    onPageChange(event: PageEvent): void {
      this.pageSize = event.pageSize;
      const newPageIndex = event.pageIndex + 1;
      this.currentPage = newPageIndex;
      this.getCollegeData();
      this.keypress();
    }

    getCollegeData() {
      if(this.userPermission[0].CgUi == 'C'){
        this.UserCollege= this.userPermission[0].CgId;
      }
      else{
        this.UserCollege = ''
      }
      this.spinner.show();
      const payload = {};
       payload['PageSize'] = this.pageSize;
      payload['PageNumber'] = this.currentPage;
      payload['CgOnlyCent'] = 1;
      payload['CgCode'] = this.UserCollege
      this.umsService.getCollege(payload).subscribe((res) => {
        if(res.status){
          this.spinner.hide();
          this.collegedataList = res.data;
          this.totalItems = res.data[0].TotalRecords;
        }
        else{
          this.collegedataList = [];
          this.spinner.hide();
        }
      
      },(ERROR: HttpErrorResponse) => {
        this.collegedataList = [];
        this.spinner.hide();
      })
    }
  

    keypress() {
      if(this.setIntervalSearch){
        clearTimeout(this.setIntervalSearch);
      }
      this.setIntervalSearch = setTimeout(()=>{
        this.spinner.show()
        this.collegedataList = [];
        const payload = {};
        payload['SearchString'] = this.CollegeDataSearchForm.value['SearchString']
           payload['PageSize'] = this.pageSize;
          if (payload['SearchString'] === "") {
            payload['PageNumber'] = this.currentPage;
          } else {
            payload['PageNumber'] = 1;
          }
        this.umsService.searchCollege(payload).subscribe((res) => {
            if(res.status){
              this.spinner.hide()
              this.collegedataList = res.data;
              this.totalItems = res.data[0].TotalRecords;
            }
            else{
              this.spinner.hide()
              this.collegedataList = [];
              this.totalItems = 0
            }
           
            }, (ERROR: HttpErrorResponse) => {
              this.spinner.hide()
              this.collegedataList = [];
              this.totalItems = 0
          });
      },1000)
      
    }

  addnewrecord() {
    const dialogRef = this.dialog.open(CollegeDialogBoxComponent, {
      width: '90vh',
      data: { key: "New" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getCollegeData();
      this.CollegeDataSearchForm.controls['SearchString'].setValue('');
    });
  }

  editData(k) {
    const dialogRef = this.dialog.open(CollegeDialogBoxComponent, {
      width: '90vh',
      data: { selected: k, key: "Edit" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getCollegeData();
      this.CollegeDataSearchForm.controls['SearchString'].setValue('');
    });
  }

  deleteData(k) {
    const dialogRef = this.dialog.open(CollegeDialogBoxComponent, {
      width: '90vh',
      data: { selected: k, key: "Delete" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getCollegeData();
      this.CollegeDataSearchForm.controls['SearchString'].setValue('');
    });
  }

  Print(){
    const dialogRef = this.dialog.open(CollegePrintComponent, {
      width: '100vh',
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getCollegeData();
      this.CollegeDataSearchForm.controls['SearchString'].setValue('');
    });
  }

  redirect(to): void {
    this.router.navigate([to]);
  }
 
}
